import { render, staticRenderFns } from "./modalEditSponsor.vue?vue&type=template&id=b8f58ff8&"
import script from "./modalEditSponsor.vue?vue&type=script&lang=js&"
export * from "./modalEditSponsor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports